import DateUtils from '@/utils/DateUtils';
import { EventSwimlineDTO } from '@/data/dtos/Events/EventSwimlineDTO';

export class EventAgendaDTO {
	constructor(public days: EventAgendaDayDTO[]) {}

	public isOneDay(): boolean {
		return this.days.length === 1;
	}
}

export class EventAgendaDayDTO {
	constructor(
		public date: Date,
		public swimlines: EventSwimlineDTO[],
	) {}

	public getDate(locale: string, short: boolean = false): string {
		return DateUtils.formatDate(this.date, locale);
	}
}
